import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Check, X, Minus } from "lucide-react";
import { api } from "../lib/api";

// Publieke, alleen-lezen deelnemerslijst voor coaches (gedeeld via admin → les → Deel link).
export default function Roster() {
  const { token } = useParams();
  const [data, setData] = useState(null);
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const res = await api.get(`/roster/${token}`);
        setData(res.data);
      } catch {
        setError(true);
      }
      setLoading(false);
    })();
  }, [token]);

  const dateLabel = data?.date
    ? new Date(data.date + "T00:00:00").toLocaleDateString("nl-NL", { weekday: "long", day: "numeric", month: "long" })
    : "";

  return (
    <main className="min-h-screen bg-[#0A0A0A] text-[#F5F3F0] grain grain-dark" data-testid="roster-page">
      <div className="max-w-lg mx-auto px-6 py-10">
        <Link to="/" className="font-logo text-3xl accent-hover" data-testid="roster-logo">JOH.</Link>

        {loading ? (
          <div className="mt-16 chip text-[#A3A3A3]" data-testid="roster-loading">Laden…</div>
        ) : error || !data ? (
          <div className="mt-16 border border-[#F5F3F0]/15 p-8 text-center" data-testid="roster-error">
            <h1 className="font-display uppercase text-3xl">Link niet actief.</h1>
            <p className="chip text-[#A3A3A3] mt-3">Vraag de beheerder om een nieuwe deellink.</p>
          </div>
        ) : (
          <>
            <motion.div initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }} className="mt-10">
              <div className="chip text-[#A3A3A3] capitalize">{dateLabel}{data.start ? ` · ${data.start}${data.end ? ` – ${data.end}` : ""}` : ""}</div>
              <h1 className="font-display uppercase text-5xl leading-[0.9] mt-3" data-testid="roster-title">{data.class_type}</h1>
              <div className="chip text-[#A3A3A3] mt-3">
                {data.coach ? `Coach ${data.coach} · ` : ""}{data.going}/{data.capacity || "—"} deelnemers
                {data.present_count > 0 && (
                  <span className="ml-2" style={{ color: "#4ADE80" }}>· {data.present_count} aanwezig</span>
                )}
              </div>
            </motion.div>

            <div className="mt-10 line-t line-dark" data-testid="roster-list">
              {data.attendees.length === 0 && (
                <div className="py-10 text-center chip text-[#A3A3A3]" data-testid="roster-empty">Nog geen deelnemers.</div>
              )}
              {data.attendees.map((a, i) => (
                <motion.div
                  key={i}
                  initial={{ opacity: 0, y: 10 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ delay: i * 0.04, duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
                  className="line-b line-dark py-4 flex items-center gap-3"
                  data-testid={`roster-attendee-${i}`}
                >
                  <span className="chip text-[#4A4A4A] w-7">{String(i + 1).padStart(2, "0")}</span>
                  <span className="font-display uppercase text-xl flex-1">{a.name}</span>
                  {a.is_trial && (
                    <span className="chip px-2 py-0.5" style={{ color: "var(--joh-accent)", border: "1px solid rgba(212,169,58,0.5)" }}>Trial</span>
                  )}
                  <span data-testid={`roster-presence-${i}`}>
                    {a.attended === true && <Check size={18} style={{ color: "#4ADE80" }} />}
                    {a.attended === false && <X size={18} style={{ color: "#F87171" }} />}
                    {a.attended !== true && a.attended !== false && <Minus size={18} className="text-[#4A4A4A]" />}
                  </span>
                </motion.div>
              ))}
            </div>

            <div className="chip text-[#4A4A4A] mt-8">JOH. Boxing · Rhoneweg 38, Amsterdam</div>
          </>
        )}
      </div>
    </main>
  );
}
